import { render, staticRenderFns } from "./MainBase.vue?vue&type=template&id=e27ec748&scoped=true"
import script from "./MainBase.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainBase.vue?vue&type=style&index=0&id=e27ec748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ec748",
  null
  
)

export default component.exports